// extracted by mini-css-extract-plugin
export default {"wrapper":"vrkAf","block":"vaojR","text":"q4YP4"};